import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

import { ItinerarioComponent } from '../../components/itinerario/itinerario.component';
import { Itinerario } from '../../models/itinerario';
import {Travel} from '../../models/travel';
import {TravelsHandlerService} from '../../api-handlers/travels-handler.service';
import {SnackBarHandlerService} from '../../commons/snack-bar-handler.service';

@Component({
	selector: 'app-end-travel',
	templateUrl: './end-travel.component.html',
	styleUrls: ['./end-travel.component.css']
})
export class EndTravelComponent implements OnInit {
	minDate;
	maxDate = new Date();
	travelToEnd?: Travel;
	@ViewChild('template', { static: false }) template;
	@Output() travelEnded = new EventEmitter<boolean>();
	itinerario: Itinerario[] = [];
	@ViewChild('itinerarioComp', { static: false }) itinerarioComponent: ItinerarioComponent;

	dom_elements = {
		end_btn: {
			is_running: false,
			txt_run: 'SALVATAGGIO IN CORSO...',
			txt_not_run: 'FINE VIAGGIO'
		},
		endTrip: {
			is_running: false,
			txt_run: 'CONCLUSIONE VIAGGIO IN CORSO...',
			txt_not_run: 'FINE VIAGGIO'
		},
		active_step: 0

	};

	constructor(
		public travelsHandlerService: TravelsHandlerService,
		public travelsService: TravelsHandlerService,
		public snackBarHandler: SnackBarHandlerService,
		public bsModalRef: BsModalService,
	) { }

	ngOnInit() {
		this.itinerario = JSON.parse(this.travelToEnd.route);

		this.travelsService.getMaxKm(this.travelToEnd).then((res: number) => {
			this.travelToEnd.end_kilometers = `${res}`;
			this.travelToEnd.ended_at = this.maxDate;
		}).catch((err) => {
			this.snackBarHandler.showSnackbar(`Errore ${err}`, 3000);
		});
	}

	onDateChange (e) {
		if (e > this.maxDate) {
			this.travelToEnd.ended_at = this.maxDate;
		} else {
			if (e < this.minDate) {
				this.travelToEnd.ended_at = this.minDate;
			} else {
				this.travelToEnd.ended_at = e;
			}
		}
	}

	endTravel() {
		this.dom_elements.endTrip.is_running = true;

		this.isEndTravelComplete().then(res => {
			if (res) {
				this.travelToEnd.route = JSON.stringify(this.itinerario);
				this.travelToEnd.route_modified = !this.itinerarioComponent.getDidUserModify();
				
				const chilometri_percorsi = (+this.travelToEnd.end_kilometers) - (+this.travelToEnd.start_kilometers);
				const r = confirm('Confermi di aver percorso ' + chilometri_percorsi +  ' chilometri?');
				if (r === true) {
					this.getCurrentPosition((lat, lon, alt) => {

						this.travelToEnd.end_latitude = lat;
						this.travelToEnd.end_longitude = lon;
						this.travelToEnd.end_altitude = alt;

						this.travelsService.closeTravel(this.travelToEnd).then((travel: Travel) => {
							// this.travelToEnd = new Travel(undefined);
							// this.travelToEnd.user = this.authService.getAuthenticatedUser();
							this.travelEnded.emit();
							this.bsModalRef.hide();
							// this.viewStartTrip();
							this.snackBarHandler.showSnackbar('Viaggio chiuso con successo', 3000);
						}).catch(() => {
							this.snackBarHandler.showSnackbar('Chiusura viaggio non riuscita. Verificare il numero di chilometri inserito. ' +
								'Ricarica la pagina.', 3000);
						}).then(() => {
							this.dom_elements.endTrip.is_running = false;
						});

					});
				} else {
					// non conferma
					this.dom_elements.endTrip.is_running = false;
				}

			} else {
				this.dom_elements.endTrip.is_running = false;
			}
		}).catch(() => {
			this.dom_elements.endTrip.is_running = false;
		});
	}

	isItinerarioValid(): boolean {
		let validity = true;
		
		this.itinerario.forEach((item) => {
			if (item.da.length === 0 || item.a.length === 0) {
				validity = false;
			}
		});

		return validity;
	}

	isEndTravelComplete(): Promise<boolean> {
		return new Promise<boolean>((resolve, reject) => {

			if (!this.isItinerarioValid()) {
				this.snackBarHandler.showSnackbar('Impostare itinerario valido', 3000);
			} else if (!this.travelToEnd.ended_at) {
				this.snackBarHandler.showSnackbar('Impostare data di fine viaggio valida', 3000);
				resolve(false);
			} else if (!this.travelToEnd.end_kilometers) {
				this.snackBarHandler.showSnackbar('Impostare chilometri attuali autovettura', 3000);
				resolve(false);
			} else if (!this.travelToEnd.fuel_level) {
				this.snackBarHandler.showSnackbar('Campo livello serbatoio non impostato', 3000);
				resolve(false);
			} else if (isNaN(Number(this.travelToEnd.end_kilometers))) {
				this.snackBarHandler.showSnackbar('Valore kilometri non valido', 3000);
				resolve(false);
			} else {

				this.travelsService.getMaxKm(this.travelToEnd).then((res) => {
					if (Number(this.travelToEnd.end_kilometers) < res ||
						Number(this.travelToEnd.end_kilometers) < Number(this.travelToEnd.start_kilometers)) {
						this.snackBarHandler.showSnackbar('Chilometri attuali minori del numero di ' +
							'chilometri impostati precedentemente', 3000);
						resolve(false);
					} else {
						resolve(true);
					}
				}).catch((er) => {
					resolve(false);
				});
			}
		});
	}

	getCurrentPosition(callbackFunction) {
		callbackFunction(null, null, null);
		// navigator.geolocation.getCurrentPosition((position) => {
		// 	callbackFunction(position.coords.latitude, position.coords.longitude, position.coords.altitude);
		// }, (err) => {
		// 	callbackFunction(null, null, null);
		// });
	}

}
